import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const usuVistasApi = `${baseUrl}/usuario-vistas`;

export const allUsuVistasService = async (params) => {
  const res = await axios.get(usuVistasApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveUsuVistasService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${usuVistasApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(usuVistasApi, data, {
      headers: token({}),
    });
  }
  return res;
};

export const deleteUsuVistasService = async (id) => {
  const res = await axios.delete(`${usuVistasApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
